import * as React from 'react'
import { reduxForm, InjectedFormProps } from 'redux-form'
import { FormGroup, Button } from 'react-bootstrap'

import { FORM_LOGIN } from '../../constants/Form'
import {
  LOGIN_FORM_FIELD_EMAIL,
  LOGIN_FORM_FIELD_PASSWORD
} from '../../constants/LoginFormFieldName'
import { InputControlField } from '../../components/form/InputControl'

export interface LoginFormData {
  email: string
  password: string
}

export type LoginFormProps = InjectedFormProps<LoginFormData>

type LoginFormType = React.SFC<LoginFormProps>

const LoginForm: LoginFormType = ({ handleSubmit }) => {
  return (
    <form onSubmit={handleSubmit}>
      <InputControlField
        label="Email"
        name={LOGIN_FORM_FIELD_EMAIL}
        type="text"
        placeholder="Email"
      />
      <InputControlField
        label="Heslo"
        name={LOGIN_FORM_FIELD_PASSWORD}
        type="password"
        placeholder="Heslo"
      />
      <FormGroup>
        <Button bsStyle="primary" type="submit">
          Prihlasit se
        </Button>
      </FormGroup>
    </form>
  )
}

export default reduxForm<LoginFormData>({
  form: FORM_LOGIN
})(LoginForm)



// WEBPACK FOOTER //
// ./src/screens/login/LoginForm.tsx